import {useState } from "react";
import useTable from '../../../hooks/table';
import TableFooter from '../../../hooks/table/footer';

const TotalizaResultados = ({ totales, totalPorAtender, totalAtendidos, totalDia }) => {
   const [page, setPage] = useState(1);
   //const { slice, range } = useTable(totales, page, 10);  

  return (
    <div className='flex flex-col w-full mb-4 items-center justify-center'>
       <div className="mt-2 rounded-lg border border-stone-200 w-[80%] overflow-x-auto">
           <table className="w-full table-auto">
               <thead className="border-b border-stone-200 text-sm font-medium">
                  <tr>
                     <th className="px-2.5 py-2 text-start font-medium">Nombre de Servicio</th>
                     <th className="px-2.5 py-2 text-start font-medium">Por Atender</th>
                     <th className="px-2.5 py-2 text-start font-medium">Atendidos</th>
                     <th className="px-2.5 py-2 text-start font-medium">Total del día</th>                     
                  </tr>
               </thead>
               <tbody className="group text-sm text-stone-800 ">
                  {Object.entries(totales).map(([NombreServ, total]) => (
                    <tr key={NombreServ}>
                      <td>{NombreServ}</td>
                      <td className="center">{total['Por Atender']}</td>
                      <td className="center">{total['Atendidos']}</td>
                      <td className="center">{total['Por Atender'] + total['Atendidos']}</td>
                    </tr>
                  ))}
               </tbody>
               <tfoot>
                 <tr>
                     <td className="center">Total General</td>
                     <td className="center">{totalPorAtender}</td>
                     <td className="center">{totalAtendidos}</td>
                     <td className="center">{totalDia}</td>
                 </tr>
               </tfoot>
           </table>
       </div> 
     
    </div>  
    );
};

export default TotalizaResultados;
